import KunLoading56 from './src/index'

KunLoading56.install = function (Vue) {
	Vue.component(KunLoading56.name, KunLoading56);
}

export default KunLoading56;
